/**
 * Los colores de las piezas de la landing.
 *
 * Cada funcionalidad tiene el suyo para que la sección se lea como piezas
 * distintas y no como un bloque de un solo color. Tres están fijos porque
 * significan algo: el naranja de la marca es del dato principal —lo que tiene
 * que saltar—, el verde es WhatsApp y el violeta es la plata. El resto están
 * repartidos para que dos piezas vecinas nunca sean del mismo color; llegaron a
 * estar cuatro seguidas en azul y la mitad de abajo del mosaico parecía una
 * sola tarjeta gigante.
 *
 * Son clases escritas enteras a propósito: Tailwind solo genera las que
 * encuentra literalmente en el código, así que armarlas con `bg-${x}-50` no
 * produciría ningún estilo.
 *
 * Vive acá y no adentro del mosaico porque lo usan dos componentes: el mosaico
 * (`MosaicoFuncionalidades`) y las filas de los features principales
 * (`FilaDeFuncionalidad`). Con una copia en cada uno, un color nuevo entraba en
 * uno solo y las dos mitades de la sección dejaban de combinar.
 */
export const TONOS = {
  naranja: { chip: 'bg-primary/10', icono: 'text-primary' },
  violeta: { chip: 'bg-violet-100', icono: 'text-violet-600' },
  verde: { chip: 'bg-emerald-100', icono: 'text-emerald-600' },
  ambar: { chip: 'bg-amber-100', icono: 'text-amber-600' },
  azul: { chip: 'bg-sky-100', icono: 'text-sky-600' },
  rosa: { chip: 'bg-rose-100', icono: 'text-rose-600' },
  agua: { chip: 'bg-teal-100', icono: 'text-teal-600' },
  indigo: { chip: 'bg-indigo-100', icono: 'text-indigo-600' },
};

export default TONOS;
